export default __webpack_public_path__ + "static/media/faq-desktop.a6f9fffd.webp";